import { render, staticRenderFns } from "./production_list.vue?vue&type=template&id=4d5d7ef9"
import script from "./production_list.vue?vue&type=script&lang=js"
export * from "./production_list.vue?vue&type=script&lang=js"
import style0 from "./production_list.vue?vue&type=style&index=0&id=4d5d7ef9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports